import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgDisposal32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path d="M26.743 9.494a.468.468 0 0 1 .64.166c3.456 5.987 1.331 13.707-4.736 17.21a12.69 12.69 0 0 1-11.62.579l1.261 2.185a.468.468 0 0 1-.175.637.468.468 0 0 1-.64-.167l-1.857-3.217a.468.468 0 0 1 .175-.637l3.26-1.882a.468.468 0 0 1 .64.167.468.468 0 0 1-.175.637l-2.312 1.335a11.75 11.75 0 0 0 10.979-.442c5.618-3.243 7.585-10.39 4.385-15.934a.468.468 0 0 1 .175-.637M20.538.746a.468.468 0 0 1 .64.166l1.857 3.217a.468.468 0 0 1-.176.638L19.6 6.649a.468.468 0 0 1-.64-.167.468.468 0 0 1 .176-.637l2.311-1.335a11.75 11.75 0 0 0-10.978.441C4.85 8.195 2.883 15.343 6.083 20.886a.468.468 0 0 1-.175.637.468.468 0 0 1-.64-.167C1.812 15.37 3.936 7.65 10.004 4.147a12.69 12.69 0 0 1 11.62-.579l-1.262-2.185a.468.468 0 0 1 .176-.637" className="disposal-32_svg__path-1" /></SvgIcon>;
};
const Memo = memo(SvgDisposal32);
export default Memo;